import React, { useState } from "react";
import { Table, DatePicker, Space } from "antd";
import classnames from "classnames";
import { AiOutlineLeftCircle } from "react-icons/ai";
import { Link } from "react-router-dom";

import { DateFormat } from "../../../../constants";
import { Header } from "../../../../components/header";

import styles from "./CompanyOfficeStatistic.module.scss";

import { requestStatusTypes } from "../../info-technology-process/types";
import { countStatus, filterRequestsByRangeDate } from "../../utils";
import { useBusinessTicketsRequests } from "../../company-office/business-tickets-v2/hooks";
import { useExternalVehicleTravelCardRequests } from "../../company-office/external-vehicle-travel-card/hooks";
import { useVehicleRequests } from "../../company-office/request-vehicle/hooks";
import { useSecurityCardUnitsRequests } from "../../company-office/securityCardUnits/hooks";
import { useSecurityControlCardRequests } from "../../company-office/sercurity-control-card/hooks";
import { useVehicleTravelCardRequests } from "../../company-office/vehicle-travel-card/hooks";

const { RangePicker } = DatePicker;

enum CompanyOfficeDepartment {
  BusinessVehicle = "business-vehicle",
  BusinessTickets = "business-tickets",
  SecurityControlCard = "security-control-card",
  SecurityCardsToExternalEntities = "security-cards-to-external-entities",
  BusinessVehicleCard = "business-vehicle-card",
  ExternalBusinessVehicleCard = "external-business-vehicle-card",
}

const CompanyOfficeStatisticPage = () => {
  const [rangeDate, setRangeDate] = useState(null);
  //-------------------------------------------------------------
  const { mappedBusinessTicketsRequests } = useBusinessTicketsRequests();
  const { mappedExternalVehicleTravelCardRequests } = useExternalVehicleTravelCardRequests();
  const { mappedVehicleRequests } = useVehicleRequests();
  const { mappedSecurityCardUnitsRequests } = useSecurityCardUnitsRequests();
  const { mappedSecurityControlCardRequests } = useSecurityControlCardRequests();
  const { mappedVehicleTravelCardRequests } = useVehicleTravelCardRequests();

  // Filter by createdDateTime
  const filteredBusinessTicketsByCreatedDateTime = filterRequestsByRangeDate(mappedBusinessTicketsRequests, rangeDate);
  const filteredExternalVehicleTravelCardByCreatedDateTime = filterRequestsByRangeDate(
    mappedExternalVehicleTravelCardRequests,
    rangeDate,
  );
  const filteredVehicleByCreatedDateTime = filterRequestsByRangeDate(mappedVehicleRequests, rangeDate);
  const filteredSecurityCardUnitsByCreatedDateTime = filterRequestsByRangeDate(
    mappedSecurityCardUnitsRequests,
    rangeDate,
  );
  const filteredSecurityControlCardByCreatedDateTime = filterRequestsByRangeDate(
    mappedSecurityControlCardRequests,
    rangeDate,
  );
  const filteredVehicleTravelCardByCreatedDateTime = filterRequestsByRangeDate(
    mappedVehicleTravelCardRequests,
    rangeDate,
  );

  // Mapping
  const businessTicketsStatusCounts = countStatus(filteredBusinessTicketsByCreatedDateTime);
  const externalVehicleTravelCardStatusCounts = countStatus(filteredExternalVehicleTravelCardByCreatedDateTime);
  const vehicleStatusCounts = countStatus(filteredVehicleByCreatedDateTime);
  const securityCardUnitsStatusCounts = countStatus(filteredSecurityCardUnitsByCreatedDateTime);
  const securityControlCardStatusCounts = countStatus(filteredSecurityControlCardByCreatedDateTime);
  const vehicleTravelCardStatusCounts = countStatus(filteredVehicleTravelCardByCreatedDateTime);

  const totalVotes =
    businessTicketsStatusCounts.total +
    securityCardUnitsStatusCounts.total +
    externalVehicleTravelCardStatusCounts.total +
    vehicleStatusCounts.total +
    securityControlCardStatusCounts.total +
    vehicleTravelCardStatusCounts.total;

  const columns = [
    {
      title: "Tên quy trình",
      dataIndex: "processName",
      key: "processName",
      align: "left" as const,
    },
    {
      title: "Số phiếu",
      dataIndex: "total",
      key: "total",
      align: "center" as const,
      render: (text: string) => <span className={styles.totalText}>{text}</span>,
    },
    {
      title: "Đang đợi thực thi",
      dataIndex: requestStatusTypes.submittedAssignee,
      key: requestStatusTypes.submittedAssignee,
      align: "center" as const,
      render: (text: string, record: any) => (
        <Link
          style={{ textDecoration: "none" }}
          to={`/procedure/${record.key}?status=${requestStatusTypes.submittedAssignee}`}
        >
          {text || 0}
        </Link>
      ),
    },
    {
      title: "Đang đợi duyệt",
      dataIndex: requestStatusTypes.submitted,
      key: requestStatusTypes.submitted,
      align: "center" as const,
      render: (text: string, record: any) => (
        <Link style={{ textDecoration: "none" }} to={`/procedure/${record.key}?status=${requestStatusTypes.submitted}`}>
          {text || 0}
        </Link>
      ),
    },
    {
      title: "Đã duyệt",
      dataIndex: requestStatusTypes.approved,
      key: requestStatusTypes.approved,
      align: "center" as const,
      render: (text: string, record: any) => (
        <Link style={{ textDecoration: "none" }} to={`/procedure/${record.key}?status=${requestStatusTypes.approved}`}>
          {text || 0}
        </Link>
      ),
    },
    {
      title: "Đang thực hiện",
      dataIndex: requestStatusTypes.inProgress,
      key: requestStatusTypes.inProgress,
      align: "center" as const,
      render: (text: string, record: any) => (
        <Link
          style={{ textDecoration: "none" }}
          to={`/procedure/${record.key}?status=${requestStatusTypes.inProgress}`}
        >
          {text || 0}
        </Link>
      ),
    },
    {
      title: "Đã tiếp nhận",
      dataIndex: requestStatusTypes.acceptance,
      key: requestStatusTypes.acceptance,
      align: "center" as const,
      render: (text: string, record: any) => (
        <Link
          style={{ textDecoration: "none" }}
          to={`/procedure/${record.key}?status=${requestStatusTypes.acceptance}`}
        >
          {text || 0}
        </Link>
      ),
    },
    {
      title: "Đã hoàn tất",
      dataIndex: requestStatusTypes.completed,
      key: requestStatusTypes.completed,
      align: "center" as const,
      render: (text: string, record: any) => (
        <Link style={{ textDecoration: "none" }} to={`/procedure/${record.key}?status=${requestStatusTypes.completed}`}>
          {text || 0}
        </Link>
      ),
    },
    {
      title: "Đã từ chối",
      dataIndex: requestStatusTypes.rejected,
      key: requestStatusTypes.rejected,
      align: "center" as const,
      render: (text: string, record: any) => (
        <Link style={{ textDecoration: "none" }} to={`/procedure/${record.key}?status=${requestStatusTypes.rejected}`}>
          {text || 0}
        </Link>
      ),
    },
  ];

  const dataSource = [
    {
      key: CompanyOfficeDepartment.BusinessVehicle,
      processName: "Sử dụng xe công vụ",
      ...vehicleStatusCounts,
    },
    {
      key: CompanyOfficeDepartment.BusinessTickets,
      processName: "Cấp vé công tác",
      ...businessTicketsStatusCounts,
    },
    {
      key: CompanyOfficeDepartment.SecurityControlCard,
      processName: "Cấp thẻ KSAN cho nội bộ VIAGS",
      ...securityControlCardStatusCounts,
    },
    {
      key: CompanyOfficeDepartment.SecurityCardsToExternalEntities,
      processName: "Cấp thẻ KSAN cho đơn vị ngoài (Đối tác)",
      ...securityCardUnitsStatusCounts,
    },
    {
      key: CompanyOfficeDepartment.BusinessVehicleCard,
      processName: "Cấp giấy phép KSAN cho phương tiện VIAGS",
      ...externalVehicleTravelCardStatusCounts,
    },
    {
      key: CompanyOfficeDepartment.ExternalBusinessVehicleCard,
      processName: "Cấp giấy phép KSAN cho đơn vị ngoài",
      ...vehicleTravelCardStatusCounts,
    },
  ];

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.wrapper}>
        <Space size="small">
          <Link to="/procedure/statistics">
            <AiOutlineLeftCircle size={38} color="gray" />
          </Link>
          <h1 className={styles.title}>Thống kê VPCT</h1>
        </Space>

        <div className={styles.selectRangeDateWrapper}>
          <div>
            <p className={styles.selectRangeDateLabel}>Chọn ngày</p>
            <RangePicker
              value={rangeDate}
              onChange={(dates: any) => setRangeDate(dates)}
              placeholder={["Ngày bắt đầu", "Ngày kết thúc"]}
              format={DateFormat.DD_MM_YYY}
            />
          </div>
        </div>
        <Table
          bordered
          pagination={false}
          dataSource={dataSource}
          columns={columns}
          title={() => <div className={styles.tableHeader}>BP. VPCT: {totalVotes} phiếu</div>}
          summary={(pageData) => {
            if (!pageData.length) return null;

            const totalVotes = pageData.reduce((total, current) => (total += current?.total || 0), 0);
            const totalSubmittedAssignee = pageData.reduce(
              (total, current) => (total += current[requestStatusTypes.submittedAssignee] || 0),
              0,
            );
            const totalSubmitted = pageData.reduce(
              (total, current) => (total += current[requestStatusTypes.submitted] || 0),
              0,
            );
            const totalApproved = pageData.reduce(
              (total, current) => (total += current[requestStatusTypes.approved] || 0),
              0,
            );
            const totalInProgress = pageData.reduce(
              (total, current) => (total += current[requestStatusTypes.inProgress] || 0),
              0,
            );
            const totalAcceptance = pageData.reduce(
              (total, current) => (total += current[requestStatusTypes.acceptance] || 0),
              0,
            );
            const totalCompleted = pageData.reduce(
              (total, current) => (total += current[requestStatusTypes.completed] || 0),
              0,
            );
            const totalRejected = pageData.reduce(
              (total, current) => (total += current[requestStatusTypes.rejected] || 0),
              0,
            );

            return (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}>
                  <div className={styles.totalLabel}>Tổng cộng</div>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1}>
                  <div className={classnames("flex-center", styles.totalText)}>{totalVotes}</div>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2}>
                  <div className={classnames("flex-center", styles.totalText)}>{totalSubmittedAssignee}</div>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                  <div className={classnames("flex-center", styles.totalText)}>{totalSubmitted}</div>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                  <div className={classnames("flex-center", styles.totalText)}>{totalApproved}</div>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                  <div className={classnames("flex-center", styles.totalText)}>{totalInProgress}</div>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                  <div className={classnames("flex-center", styles.totalText)}>{totalAcceptance}</div>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                  <div className={classnames("flex-center", styles.totalText)}>{totalCompleted}</div>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4}>
                  <div className={classnames("flex-center", styles.totalText)}>{totalRejected}</div>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            );
          }}
        />
      </div>
    </div>
  );
};

export default CompanyOfficeStatisticPage;
